define('ShippingByLocation.Collection', [
  'underscore',
  'Utils',
  'SCCollection',
  'DateCalculations',
  'ShippingByLocation.Model'
], function ShippingByLocationCollectionModule(
  _,
  Utils,
  SCCollectionComponent,
  DateCalculations,
  ShippingByLocationModel
) {
  'use strict';

  var SCCollection = SCCollectionComponent.SCCollection;

  function ShippingByLocationCollection(models, options) {
    SCCollection.call(this, models, options);

    this.model = ShippingByLocationModel;
    this.url = function url() {
      return Utils.getAbsoluteUrl(getExtensionAssetsPath('services/ShippingByLocation.Service.ss'));
    };

    // initialize attributes
    this.zipCode = null;
    this.locationIds = [];
  }

  ShippingByLocationCollection.prototype = Object.create(SCCollection.prototype);

  _.extend(ShippingByLocationCollection.prototype, {
    constructor: ShippingByLocationCollection,

    comparator: function comparator(model1, model2) {
      var estimatedShippingMin1 = model1.getEstimatedShippingMin();
      var estimatedShippingMin2 = model2.getEstimatedShippingMin();
      var minTime1 = estimatedShippingMin1 ? estimatedShippingMin1.days : null;
      var minTime2 = estimatedShippingMin2 ? estimatedShippingMin2.days : null;
      var timeComparison = DateCalculations.compareShippingTimes(minTime1, minTime2);
      // if shipping time is different, return comparison
      if (timeComparison !== 0) {
        return timeComparison;
      }
      // if same shipping time, compare cutoff
      return DateCalculations.compareTimeOfDayToday(
        model1.getCutOffTimeData(),
        model2.getCutOffTimeData()
      );
    },

    setZipCode: function setZipCode(zipCode) {
      this.zipCode = zipCode;
    },

    getZipCode: function getZipCode() {
      return this.zipCode;
    },

    clearZipCode: function clearZipCode() {
      this.zipCode = null;
    },

    setLocationIds: function setLocationIds(locationIds) {
      this.locationIds = locationIds;
    },

    setSubsidiaries: function setSubsidiaries(subsidiaries) {
      this.subsidiaries = subsidiaries;
    },

    getLocationIds: function getLocationIds() {
      return this.locationIds;
    },

    clearLocationIds: function clearLocationIds() {
      this.locationIds = [];
    },

    getFastestShippingLocation: function getFastestShippingLocation() {
      // already sorted using `comparator` function
      return this.first();
    },

    update: function update() {
      var data = {};
      /* eslint-disable */
      if (this.zipCode) {
        data.zip_code = this.zipCode;
      }
      if (this.locationIds && this.locationIds.length > 0) {
        data.location_ids = this.locationIds.join(',');
      }
      if (this.subsidiaries && this.subsidiaries.length > 0) {
        data.subsidiaries = this.subsidiaries.join(',');
      }
      /* eslint-enable */
      return this.fetch({ data: data });
    }
  });

  return ShippingByLocationCollection;
});
